/**
 * Public URL of a listing, for admin reports that link out to the live page.
 *
 * The slug rule has to match the one the backend uses when it creates the link
 * record — `slugFromName` in modules/services.js and the `slugify` in
 * routes/admin.js — because /view-post/:serviceName is resolved by looking the
 * slug up (POST /api/serviceslinklist { url }). A slug that merely
 * encodeURIComponent()s the title keeps its capitals, turns spaces into %20 and
 * leaves punctuation in, so it matches nothing and the link 404s.
 *
 * Rows that came from a page-view event carry the exact slug the visitor was
 * on (ViewAds records it as serviceSlug); that always beats re-deriving one.
 */

export function postSlug(item) {
  if (!item) return "";
  // Only ever the stored slug. Deriving one from the title is what opened the
  // WRONG listing: duplicate titles are disambiguated by a "+1"/"+2" suffix, so
  // two rows both titled "Testing" really live at "testing+5" and "testing+6",
  // while the derived "testing" is a third, unrelated listing. A title cannot
  // tell you which of them a row means, so a row with no stored slug gets no
  // link rather than a plausible-looking wrong one.
  return item.serviceSlug ? String(item.serviceSlug) : "";
}

export function postUrl(item) {
  const slug = postSlug(item);
  if (!slug) return "";
  // "+" must stay literal. Duplicate titles are disambiguated by a "+1"/"+2"
  // suffix on the stored slug, and ViewAds looks the listing up using
  // window.location.pathname, which does NOT percent-decode — so a href of
  // …-room%2B1 is searched for as the literal string "…-room%2B1", matches no
  // link record, and the page comes up empty. Everything else stays escaped.
  return `/view-post/${encodeURIComponent(slug).replace(/%2B/g, "+")}`;
}
